import type { CSSProperties } from 'react';

const HERO_STAT_LABEL: CSSProperties = {
  fontSize: 9.5,
  fontWeight: 700,
  letterSpacing: '0.08em',
  opacity: 0.55,
  textTransform: 'uppercase',
};

/** One labelled figure on the week-ahead card. */
export default function MobileHeroStat({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div style={HERO_STAT_LABEL}>{label}</div>
      <div className="nb-tabular" style={{ fontSize: 16, fontWeight: 700, marginTop: 2 }}>
        {value}
      </div>
    </div>
  );
}
